// TagFolderCustomNode.js
import { Tooltip, Typography } from "@material-ui/core";
import { ArrowRight } from "@material-ui/icons";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import FolderIcon from "@material-ui/icons/Folder";
import InsertChartIcon from "@material-ui/icons/InsertChart";
import { NodeModel, RenderParams } from "@minoru/react-dnd-treeview";
import React, { useCallback, useEffect } from "react";
import { TagFromTree } from "../../../models/TagsTree.model";
import { useTagsTreeModalStyles } from "../../../styles/TasgTreeModalStyles";

interface CustomNodeProps {
	node: NodeModel<TagFromTree>;
	setContextMenuOver: (
		data: NodeModel<TagFromTree>,
		e: React.MouseEvent<HTMLElement>,
	) => void;
	options: RenderParams;
	openTagFolders: {
		[TagId: string]: string | number;
		[TagId: number]: string | number;
	};
	handleSelect: (node: NodeModel<TagFromTree>) => void;
	setOpenTagFolders: React.Dispatch<
		React.SetStateAction<{
			[TagId: string]: string | number;
			[TagId: number]: string | number;
		}>
	>;
	isSelected: boolean;
}

const customStyles = `
  ul, ol {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
`;

export const TagFolderCustomNode: React.FC<CustomNodeProps> = ({
	node,
	options: { depth, isOpen, onToggle, containerRef },
	options,
	setOpenTagFolders,
	openTagFolders,
	handleSelect,
	setContextMenuOver,
	isSelected,
}) => {
	const classes = useTagsTreeModalStyles();
	const nodeClasses = `${classes.customNodeRoot} ${classes.root} ${
		isSelected ? classes.selected : ""
	}`;
	const onClickHandler = () => {
		if (options.hasChild || node.data?.TagTypeCode === "F") {
			if (openTagFolders[node.id]) {
				const newOpenTagFolders = { ...openTagFolders };
				delete newOpenTagFolders[node.id as number];
				setOpenTagFolders(newOpenTagFolders);
			} else {
				setOpenTagFolders({ ...openTagFolders, [node.id]: node.id });
			}
			onToggle();
			return;
		}
		if (!options.hasChild) {
			handleSelect(node);
		}
	};

	const handleContextMenu = useCallback(
		(ev: any) => {
			ev.stopPropagation();
			ev.preventDefault();
			setContextMenuOver(node, ev);
		},
		[node.id, setContextMenuOver],
	);

	useEffect(() => {
		containerRef.current?.addEventListener("contextmenu", handleContextMenu);

		return () => {
			containerRef.current?.removeEventListener(
				"contextmenu",
				handleContextMenu,
			);
		};
	}, []);

	return (
		<div
			className={nodeClasses}
			onClick={onClickHandler}
			style={{ paddingLeft: depth * 20, cursor: "pointer" }}
		>
			<style>{customStyles}</style>
			{
				<>
					{options.hasChild ? (
						<div>{isOpen ? <ArrowDropDownIcon /> : <ArrowRight />}</div>
					) : null}

					<div>
						{options.hasChild || node.data?.TagTypeCode === "F" ? (
							<FolderIcon />
						) : (
							<InsertChartIcon fontSize="small" />
						)}
					</div>
				</>
			}
			{node.data?.TagName && (
				<>
					{node.data?.TagTypeCode && node.data?.TagTypeCode !== "F" && (
						<div
							className={classes.dataTypeOfTree}
							style={{
								backgroundColor:
									node.data?.TagTypeCode === "A" ? "#AD48C4" : "#C46F48",
								margin: "0 5px",
							}}
						>
							{node.data?.TagTypeCode}
						</div>
					)}
					<Tooltip title={node.data.TagName} placement="top" arrow>
						<Typography variant="body2">
							{node.data?.Alias || node.data?.TagName}
						</Typography>
					</Tooltip>
				</>
			)}
		</div>
	);
};
